import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS from 'components/common/icon/const'
import { withI18next } from 'lib/i18n/withI18next'
import { capitalize } from 'lib/utils/common/commonUtils'
import { hasLocizeTranslation } from 'lib/utils/locize'
import materialRating from './const'

export const RadioRank = ({ value }) => {
  const total = 5
  const radios = Array.from(Array(total).keys())

  return (
    <div
      className={clsx('feature__information', 'circles', `circles-${value}`)}
    >
      {radios.map((_, idx) => (
        <Icon
          key={idx}
          className="rank-icon"
          size={12}
          src={idx < value ? ICONS.circleFilled : ICONS.circleOutlined}
        />
      ))}
    </div>
  )
}

export const getFeature = (key, details, t) => {
  const parsedKey = key.split('_').join(' ')
  const value = details[key]
  const lowerCaseValue = value.toLowerCase()
  const shouldDisplayRadioRank =
    Object.keys(materialRating).includes(lowerCaseValue)

  return (
    <div className="feature" key={key}>
      <span className={clsx('feature__title', Typo.body2)}>
        {t(capitalize(parsedKey))}
      </span>
      {shouldDisplayRadioRank ? (
        <RadioRank value={materialRating[lowerCaseValue]} />
      ) : (
        <span className={clsx('feature__information', Typo.body2)}>
          {value}
        </span>
      )}
    </div>
  )
}

export const Materials = ({ fabrics, t }) => (
  <div className="pdp__product-materials__lists">
    <span className={clsx('title', Typo.body2)}>
      {hasLocizeTranslation(t, 'Fabric', 'Fabric')}
    </span>
    <span className={clsx('details', Typo.caption)}>
      {fabrics?.map &&
        fabrics.map((fabric) => (
          <span key={fabric.name}>{`${fabric.name} ${fabric.percent}%`}</span>
        ))}
    </span>
  </div>
)

const ProductMaterials = ({ details, t }) => {
  const { fabrics, ...value } = details
  const valueKeyList = Object.keys(value)

  return (
    <div className="pdp__product-materials">
      <Materials fabrics={fabrics} t={t} />
      {valueKeyList.length > 0 && (
        <div className="pdp__product-materials__feature">
          {valueKeyList.map((key) => getFeature(key, value, t))}
        </div>
      )}
    </div>
  )
}

RadioRank.propTypes = {
  value: PropTypes.number.isRequired,
}

Materials.propTypes = {
  fabrics: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      percent: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  t: PropTypes.func.isRequired,
}

ProductMaterials.propTypes = {
  details: PropTypes.shape({
    fabrics: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        percent: PropTypes.number.isRequired,
      }).isRequired,
    ),
    lining: PropTypes.string,
    silhouette: PropTypes.string,
    stretch: PropTypes.string,
    thickness: PropTypes.string,
    transparency: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ProductMaterials)
